<section class="debt-manager" (click)="onClickDebtManager.emit()">
  <img 
    src="../../../../../assets/images/debt-manager-bg.png"
    alt="debt manager graphic"
    class="debt-manager-img"
  > 
  <div class="debt-context">
    <p class="debt-title">Debt Manager</p>
    <p class="debt-text">Pay down debt faster with a personalized plan</p>
    <a class="debt-link">
      <span class="debt-link-text">Let's go</span>
      <app-icon-arrow
        [width]="'16'"
        [height]="'16'"
      ></app-icon-arrow>
    </a>
  </div>
</section>
